import get from "lodash/get";

const selectedScraperMiddleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
        return action(dispatch, getState);
    }

    const selectedScraper = get(getState(), "selectedScraper.value", false);

    if (selectedScraper && action.payload) {
        // eslint-disable-next-line no-param-reassign
        action.payload.id = selectedScraper;
    }

    return next(action);
};

export default selectedScraperMiddleware;
